import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Solutions', href: '#solutions' },
    { name: 'Features', href: '#features' },
    { name: 'Security', href: '#security' },
    { name: 'Pricing', href: '#pricing' },
    { name: 'About', href: '#about' },
  ];

  return (
    <nav 
      className={`fixed w-full top-0 z-50 transition-all duration-300 ${
        scrolled ? 'navbar-blur py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between">
        <Link 
          to="/" 
          className="flex items-center text-blue-600 font-display font-bold text-xl"
        >
          <img 
            src="/lovable-uploads/portco_logo.png" 
            alt="Portco AI Logo" 
            className="h-10 object-contain"
          />
        </Link>

        {/* Desktop Navigation */}
        <div className="hidden md:flex items-center space-x-8">
          <div className="flex space-x-6">
            {navLinks.map((link) => (
              <a 
                key={link.name}
                href={link.href}
                className="text-gray-700 hover:text-blue-600 relative animated-border font-medium text-sm"
              >
                {link.name}
              </a>
            ))}
          </div>
          <div className="flex space-x-3">
            <a 
              href="#contact" 
              className="bg-white text-blue-600 border border-blue-200 hover:border-blue-300 hover:bg-blue-50 transition-colors px-4 py-2 rounded-md text-sm font-medium"
            >
              Contact
            </a>
            <a 
              href="#demo" 
              className="bg-blue-600 text-white hover:bg-blue-700 transition-colors px-4 py-2 rounded-md text-sm font-medium animate-pulse-slow"
            >
              Request Demo
            </a>
          </div>
        </div>

        {/* Mobile Menu Button */}
        <button 
          className="md:hidden text-gray-700"
          onClick={toggleMenu}
          aria-label="Toggle menu"
        >
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Navigation */}
      <div 
        className={`md:hidden absolute top-full left-0 w-full bg-white border-b border-gray-200 shadow-lg transition-all duration-300 ease-in-out ${
          isOpen ? 'max-h-screen opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
        }`}
      >
        <div className="container mx-auto px-4 py-4 flex flex-col space-y-4">
          {navLinks.map((link) => (
            <a 
              key={link.name}
              href={link.href}
              className="text-gray-700 hover:text-blue-600 py-2 text-base font-medium"
              onClick={toggleMenu}
            >
              {link.name}
            </a>
          ))}
          <div className="flex flex-col space-y-3 pt-4 border-t border-gray-100">
            <a 
              href="#contact" 
              className="bg-white text-blue-600 border border-blue-200 hover:border-blue-300 hover:bg-blue-50 transition-colors px-4 py-2 rounded-md text-sm font-medium text-center"
              onClick={toggleMenu}
            >
              Contact
            </a>
            <a 
              href="#demo" 
              className="bg-blue-600 text-white hover:bg-blue-700 transition-colors px-4 py-2 rounded-md text-sm font-medium text-center"
              onClick={toggleMenu}
            >
              Request Demo
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
